import { render, staticRenderFns } from "./CustomerLots.vue?vue&type=template&id=56b6293f"
import script from "./CustomerLots.vue?vue&type=script&lang=js"
export * from "./CustomerLots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports